import { Expose } from 'class-transformer';
import { v4 as uuidv4 } from 'uuid';

export class UUID {
    @Expose()
    uuid: string = uuidv4();
}
